import { QRCode } from "antd";
import ButtonCustom from "components/base/ButtonCustom";
import { PATH } from "contants/path";
import { useAppSelector } from "hooks/app-hook";
import { useCopyToClipboard } from "hooks/useCopyToClipboard";
import { useEffect, useState } from "react";
import { selectProfile } from "store/user";
import { Container } from "styles/helper";

import { ReferralCodeStyle } from "./style.index";

const ReferralCode = () => {
  const dataProfile = useAppSelector(selectProfile);
  const [referral, setReferral] = useState<string>("");
  const [, copy] = useCopyToClipboard();
  useEffect(() => {
    if (!dataProfile?.referral_code) return;
    setReferral(dataProfile.referral_code);
  }, [dataProfile]);

  const pathReferral =
    window.location.host + PATH.register + "?referral=" + referral;

  return (
    <Container>
      <ReferralCodeStyle>
        <div className="referral__title">Referral</div>
        <div className="referral__content">
          <div className="referral__content-left">
            <QRCode value={pathReferral || ""} />
          </div>
          <div className="referral__content-right">
            <div className="header">
              <span>Referral Link</span>
            </div>
            <div className="bottom">
              <p>{pathReferral}</p>
              <ButtonCustom onClick={() => copy(pathReferral)} type="primary">
                Copy
              </ButtonCustom>
            </div>
          </div>
        </div>
      </ReferralCodeStyle>
    </Container>
  );
};

export default ReferralCode;
